import React, { useEffect, useRef } from 'react'
import { Base_API } from '../../_actions/matcher'
// style
import "./style.scss"
import '../../assets/style/main.css'
// jquery
import $ from 'jquery'
// redux
import { useDispatch, useSelector } from 'react-redux'
import { set_signin_nav_header } from '../../redux/actions/signin.action'
import { SET_SIGNIN_NAV_HEADER } from '../../redux/actions/all_action'
// assets
import ARROW_LEFT_ICON from "../../assets/images/icons/CaretLeft.png"
import CROSS_ICON from "../../assets/images/icons/x.png"

function SignIn_Navbar({canClose}) {
    const onceMount = useRef(true);
    const topicHeight = 40;

    const dispatch = useDispatch();
    let headerText = useSelector((state) => state.signInReducer.nav_header);
    
    useEffect(() => {
        if(onceMount.current)
        {
            navInit();
            onceMount.current = false;
        }
    }, [])

    const navInit = async() => {
        await headerTextInit();
        await eventInit();
    }

    const headerTextInit = () => {
        return new Promise(async resolve => {
            let prefix = Base_API.pathWeb;
            let pathName = String(location.pathname.replace(prefix, "")).replace(/' '/g, '').toLowerCase(); 
            console.log('pathName: ', pathName);
            let headerName = "";

            switch(pathName)
            {
                // Sign In
                case "/n-health/signin/policy" || "/n-health/signin/policy/"
                :
                    headerName = "ข้อกำหนดและเงื่อนไขของบริการ"
                    break
                ;
                case "/n-health/signin/overview" || "/n-health/signin/overview/"
                :
                    headerName = "การสมัคร"
                    break
                ;
                case "/n-health/signin/privacy-policy":
                case "/n-health/signin/privacy-policy/":
                case "/n-health/signup/privacy-policy":
                case "/n-health/signup/privacy-policy/"
                :
                    headerName = "นโยบายความเป็นส่วนตัว"
                    break
                ;
                // Sign Up
                case "/n-health/signup/overview" || "/n-health/signup/overview/"
                :
                    headerName = "ลงทะเบียน"
                    break
                ;
                case "/n-health/signup/idcard-ocr" || "/n-health/signup/idcard-ocr/"
                :
                    headerName = "ถ่ายรูปบัตรประชาชน"
                    break
                ;
                case "/n-health/signup/face-ocr" || "/n-health/signup/face-ocr/"
                :
                    headerName = "สแกนใบหน้า"
                    break
                ;
                case "/n-health/signup/forminfo" || "/n-health/signup/forminfo/"
                :
                    headerName = "ข้อมูลส่วนตัว"
                    break
                ;
                // KYC
                case "/n-health/kyc/overview-1" || "/n-health/kyc/overview-1/"
                :
                    headerName = "KYC"
                    break
                ;
                case "/n-health/kyc/overview-2" || "/n-health/kyc/overview-2/"
                :
                    headerName = "KYC"
                    break
                ;
                case "/n-health/kyc/idcard-ocr" || "/n-health/kyc/idcard-ocr/"
                :
                    headerName = "ถ่ายรูปบัตรประชาชน"
                    break
                ;
                case "/n-health/kyc/face-ocr" || "/n-health/kyc/face-ocr/"
                :
                    headerName = "สแกนใบหน้า"
                    break
                ;
                case "/n-health/kyc/identity-verified" || "/n-health/kyc/identity-verified/"
                :
                    headerName = "KYC"
                    break
                ;
                case "/n-health/kyc/step-1" || "/n-health/kyc/step-1/"
                :
                    headerName = "KYC"
                    break
                ;
                case "/n-health/kyc/step-2" || "/n-health/kyc/step-2/"
                :
                    headerName = "KYC"
                    break
                ;
                case "/n-health/kyc/step-3" || "/n-health/kyc/step-3/"
                :
                    headerName = "KYC"
                    break
                ;
                case "/n-health/kyc/step-4" || "/n-health/kyc/step-4/"
                :
                    headerName = "KYC"
                    break
                ;
                case "/n-health/kyc/success" || "/n-health/kyc/success/"
                :
                    headerName = "ข้อมูล KYC"
                    break
                ;
            }

            dispatch(set_signin_nav_header(headerName))
            resolve();
        })
    }

    const eventInit = () => {
        return new Promise(async resolve => {
            $( window ).on( "resize", function() {
                checkNavStyle();
            } );
            checkNavStyle()
            resolve();
        })
    }

    const checkNavStyle = () => {
        const elem_id = "#nav-headertext";
        const elem = $(elem_id);
        let hasToLineStatus = hasTwoLines(elem_id);
        if(hasToLineStatus)
        {
            elem.addClass('animated');
            elem.css('white-space', 'nowrap');
        }else
        {
            elem.removeClass('animated');
            elem.css('white-space', 'normal');
        }
    }

    function hasTwoLines(elem_id) {
        let elem = $(elem_id);    
        let elemHeight = elem.height();
        return elemHeight > topicHeight;
    }

    const goBack = () => {
        // Previos Page
        window.history.go(-1);
    }

    return (
        <div className="signin_navbar-con">
            <div className="left" onClick={goBack}>
                <img src={ARROW_LEFT_ICON} /> 
            </div>
            <div className="mid">
                <div id="nav-headertext">
                    <h2>{headerText}</h2>
                </div>
            </div>
            {canClose ?
                <div className="right">
                    <img src={CROSS_ICON} /> 
                </div>
                :
                <div></div>
            }
        </div>
    )
}

export default SignIn_Navbar